<!-- Dropped: FieldSet has no counterpart in ds-components. Pages currently using it will be migrated to PropertyList (@tundr/ds-components). -->
<script setup lang="ts">
  import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import FontIcon from '../FontIcon/FontIcon.vue';
  import { LoaderContainer, LoaderSize } from '../Loader';
  import {
    fieldSetActionsClass,
    fieldsetContainer,
    fieldSetContentClass,
    legendClass,
    titleIconClass,
  } from './FieldSet.css';
  import type { FontIconProps } from '../FontIcon/FontIcon.types.ts';

  export type FieldSetProps = {
    id?: string;
    testId?: string;
    title?: string;
    legend?: string;
    icon?: TUNDR_ICONS;
    loading?: boolean;
    iconProps?: Omit<FontIconProps, 'iconName'>;
  };

  defineProps<FieldSetProps>();
</script>

<template>
  <fieldset
    :class="fieldsetContainer"
    :id="id"
    :data-test-id="testId"
    :title="title"
  >
    <slot name="legend">
      <legend :class="legendClass">
        <FontIcon
          :icon-name="icon"
          v-if="icon"
          :class="titleIconClass"
          v-bind="iconProps"
        />
        {{ legend }}
      </legend>
    </slot>

    <div :class="fieldSetContentClass">
      <LoaderContainer v-if="loading" :size="LoaderSize.medium" min-wrapper />
      <div v-else><slot /></div>
      <div v-if="$slots.actions" :class="fieldSetActionsClass">
        <slot name="actions" />
      </div>
    </div>
  </fieldset>
</template>
